export default "__VITE_ASSET__bN4JfB8e__"